export default {
  methods: {
    sortValues(valuesToSort) {
      const groups = {};
      valuesToSort.forEach(val => {
        if (!groups[val.groupNr]) {
          groups[val.groupNr] = [];
        }
        groups[val.groupNr].push(val);
      });

      let finalGroups = [];
      for (const key of Object.keys(groups)) {
        finalGroups = finalGroups.concat(
          groups[key].sort((left, right) => {
            return this.getLocaleText(left.value).localeCompare(this.getLocaleText(right.value));
          })
        );
      }

      return finalGroups;
    }
  }
};
